module.exports = __webpack_public_path__ + "img/mind_background_12_th.cac274f8.png";